import { useNavigate } from "react-router-dom"
import { useExpand } from "../../hooks/useExpanded"
import { useEffect, useState } from "react"
import { getStorage, STORAGE } from "../../utils/storage"
import LoadingButton from "../../components/LoadingButton"
import { api } from "../../env"
import { SparkState } from "../../utils/enums"
import SparkRating from "./SparkRating"

export function SparkCard({spark, onComplete}) {

    const { expanded, handleExpand } = useExpand(spark.id)
    const [state, setState] = useState(SparkState.COMPLETED)
    const [isEditable, _] = useState(getStorage(STORAGE.PARTICIPANT_ROLE) == 'Mentee')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setState(spark.isCompleted ? SparkState.COMPLETED : SparkState.PENDING)
    }, [spark])

    const getCardStyle = () => {
        if (state == SparkState.PENDING && expanded) return "filled-primary-dark"
        if (state == SparkState.COMPLETED) return "shaded-neutral outline-card"
    }

    const navigate = useNavigate()
    
    const handleClick = () => handleExpand(spark.id)
    const handleExplore = (e) => {
        e.stopPropagation()
        navigate(`spark/${spark.sparkId}`)
    }

    const handleComplete = () => {
        setLoading(true)
        api.put(`spark-instance/${spark.id}/complete`)
            .then(res => {
                setLoading(false)
                onComplete(res.data)
            })
            .catch(err => {
                setLoading(false)
                console.log("Error trying to complete spark")
            })
    }
    
        return(
            <div className={`card clickable flex gap-m space-between center ${getCardStyle()}`} onClick={handleClick}>
                {/* flex: 1 so the rating form can use the card's full width instead of shrinking to its content */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    <p className={`card-label ${state != SparkState.COMPLETED ? 'o-65' : 'o-50'}`}>Spark {spark.order}</p>
                    <p className={`card-title ${state == SparkState.COMPLETED ? 'regular o-50' : ''}`}>{spark.name} {expanded && <span className="o-75 light">- {spark.description}</span>}</p>
                    {expanded && <>
                        <div className={`card-body showing dashed-border flex columns gap-m center ${state == SparkState.COMPLETED ? 'neutral-border' : 'o-50'} standard-padding-s vi-spacer-s`}>
                            <p className="card-label text-center o-75">Please take a few minutes to explore this spark before marking it as completed.</p>
                            <button className="solid inverted" onClick={(e) => handleExplore(e)}>Explore This Spark</button>
                        </div>
                        {isEditable && state != SparkState.COMPLETED && <div className="flex justify-end center vi-spacer-s" onClick={(e) => e.stopPropagation()}>
                            <LoadingButton className={'text inverted'} onClick={handleComplete} label={'Mark As Completed'} leadingIcon={'check'} loading={loading}/> 
                        </div>}
                        {isEditable && state == SparkState.COMPLETED && <SparkRating sparkInstanceId={spark.id}/>}
                    </>}
                </div>
                {state == SparkState.COMPLETED && <span className="material-symbols-outlined scale-m vi-spacer-xxs h-spacer-xs o-85">select_check_box</span>}
            </div>
    )
}